import { NgRxAlertsLibConfig } from '@usf/ngrx-alerts';
import { environment } from 'src/environments/environment';

export const NG_RX_ALERTS_LIB_CONFIG: NgRxAlertsLibConfig = {
    apiUrl: environment.alertsApiUrl,
    webSocketUrl: environment.webSocketUrl
};
